import styled, { css } from 'styled-components';

import { breakpoints, theme } from '@notino/react-styleguide';

import { CdnImage } from '@components/CdnImage';

import { IStyledVariantProps } from '../../../../model';
import { VariantCommon } from '../../variantsStyled';

const variantBorderColor = (props: IStyledVariantProps) => {
  const { isSelected } = props;
  return isSelected ? theme.color.border.selected : theme.color.border.divider;
};

type VariantProps = {
  newDesign: boolean;
  displayInRow: boolean;
} & IStyledVariantProps;
export const Variant = styled(VariantCommon)<VariantProps>`
  ${({ newDesign, isSelected, displayInRow }) =>
    newDesign
      ? css`
          border: 2px solid
            ${isSelected
              ? theme.color.common.gray30
              : theme.color.border.divider};
          padding: 0.625rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
          margin: 0 0 0.25rem;
          width: 6.5rem;
          height: 7.5rem;

          @media (min-width: ${breakpoints.lg}) {
            flex-direction: ${displayInRow ? 'row' : 'column'};
            width: auto;
            margin: 0;
          }
        `
      : css`
          border: 1px solid ${variantBorderColor};
          margin-right: 0.625rem;
          margin-bottom: 0.625rem;
          padding: 0.625rem;
          min-height: 7.75rem;
        `}
`;

interface IImgWrapperProps {
  isOnStock: boolean;
  isSelected: boolean;
  newDesign: boolean;
}

export const ImgWrapper = styled.span<IImgWrapperProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  background-color: ${theme.color.background.primary};

  img {
    opacity: ${(props) =>
      props.isSelected || props.isOnStock ? 1 : props.newDesign ? 0.5 : 0.6};
    overflow: hidden;
  }

  ${({ newDesign }) =>
    newDesign
      ? css`
          img {
            height: 4rem;
            width: 4rem;
            object-fit: contain;
          }
        `
      : css`
          width: 5rem;
          height: 5rem;
          img {
            max-width: 4.375rem !important;
            max-height: 4.375rem !important;
          }
        `}
`;

interface IPriceLabelWrapperProps {
  isOnStock: boolean;
  isSelected: boolean;
  newDesign: boolean;
}

export const PriceLabelWrapper = styled.div<IPriceLabelWrapperProps>`
  text-align: center;

  ${({ newDesign, isOnStock, isSelected }) =>
    newDesign
      ? css`
          ${isSelected
            ? theme.typography.labelRegular
            : theme.typography.labelRegular400}
          color: ${isSelected
            ? theme.color.text.primary
            : theme.color.text.secondary};
        `
      : css`
          color: ${isOnStock
            ? theme.color.text.primary
            : theme.color.text.disabled};
          font-weight: ${isSelected ? 'bold' : 'normal'};
          font-size: 0.9rem;
        `}
`;

// has to be used because of isVideo prop warning, as we attempt to pass to dom element isVideo prop
export const Img = styled(CdnImage)``;

export const VariantList = styled.ul<{
  newDesign: boolean;
  itemsCount: number;
}>`
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;

  ${({ newDesign, itemsCount }) =>
    newDesign
      ? css`
          display: flex;
          gap: 0.5rem;
          margin: 0;

          @media (min-width: ${breakpoints.lg}) {
            display: grid;
            grid-gap: 0.5rem;
            grid-template-columns: repeat(${itemsCount >= 3 ? 3 : 2}, 1fr);
            overflow-x: auto;
            margin: 0;
          }
        `
      : css`
          display: flex;
          flex-wrap: nowrap;
          margin: 0;

          @media (min-width: ${breakpoints.md}) {
            flex-wrap: wrap;
            height: auto;
            overflow-x: auto;
            padding: 0;
          }
        `}
`;

export const VariantListItem = styled.li<{ newDesign: boolean }>`
  list-style-type: none;
  display: inline-block;
  flex-shrink: 0;
  padding: 0;
  margin: 0;

  &:before {
    display: none;
  }

  ${({ newDesign }) =>
    !newDesign &&
    css`
      min-width: 28vw;
      @media (min-width: ${breakpoints.sm}) {
        min-width: auto;
      }
    `}
`;

export const PricePlaceholder = styled.div`
  height: 1rem;
  width: 3rem;
`;
